import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: '',
    loadChildren: () => import('./modules/views/views.module').then(m => m.ViewsModule)
  },
  {
    // Rendered in place of a page (URL unchanged, HTTP 503) when its CMS content can't be loaded
    path: 'unavailable',
    loadComponent: () => import('./layouts/service-unavailable/service-unavailable.component').then(c => c.ServiceUnavailableComponent)
  },
  {
    path: 'not-found',
    loadComponent: () => import('./layouts/not-found/not-found.component').then(c => c.NotFoundComponent),
    title: '404 - Page Not Found | pixshiv',
    data: {
      title: '404 - Page Not Found',
      description: 'Sorry, the page you are looking for could not be found. Browse our popular pages or return to the homepage.'
    }
  },
  {
    path: '**',
    redirectTo: '/not-found'
  }
];
